export default __webpack_public_path__ + "static/media/abb-color.53fd3e18.svg";